import { useMatches } from 'react-router';
import { useHeaderTitleOverride } from '@/shared/navigation';

/** 라우트 handle 에 부착하는 화면 타이틀 메타 — 타이틀 SSOT(페이지는 자체 타이틀 렌더 안 함). */
export interface RouteTitleHandle {
  /** 셸 헤더(모바일)·페이지 헤더(데스크탑)에 표시할 화면명. */
  title?: string;
  /**
   * **하위 페이지 여부** — 다른 화면에서 "들어간" 화면인가(발전소 상세·용도설정). 라우트 정의가 화면마다
   * 직접 선언한다(경로 깊이·path variable 파생 금지 — 근거는 `routes/app.ts` 헤더).
   *
   * true 면 '<' 는 히스토리가 아니라 **상위 경로**(현재 pathname 의 마지막 세그먼트 제거)로 올라간다 — `AppHeader`
   * 의 Up 내비게이션. 어느 화면이 하위인지는 사람이 선언하고, 그 상위가 어디인지는 경로가 답한다.
   */
  isSubpage?: boolean;
}

/**
 * 현재 매치 체인에서 가장 깊은 title 핸들을 읽는다(모바일 셸 헤더·데스크탑 페이지 헤더 공용). 화면이 동적 타이틀
 * (`useSetHeaderTitle`, 예: 발전소 상세=이름)을 설정했으면 그 값이 handle.title 을 덮어쓴다(isSubpage 는 handle 유지).
 * 선택 기준이 `title` 이라, title 없이 `isSubpage` 만 단 handle 은 채택되지 않는다(둘은 같은 handle 에 둘 것).
 */
export function useRouteTitle(): RouteTitleHandle {
  const override = useHeaderTitleOverride();
  const matches = useMatches();
  for (let i = matches.length - 1; i >= 0; i--) {
    const handle = matches[i]?.handle as RouteTitleHandle | undefined;
    if (handle?.title) return override ? { ...handle, title: override } : handle;
  }
  return override ? { title: override } : {};
}
